import { render, staticRenderFns } from "./AxWrapperCenter.vue?vue&type=template&id=6461c2b0"
import script from "./AxWrapperCenter.vue?vue&type=script&lang=ts"
export * from "./AxWrapperCenter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports